// extracted by mini-css-extract-plugin
export default {"container":"FullscreenContent_container__1qCk4","close":"FullscreenContent_close__h2rxa"};